
export const AIOpsLogo = ({
  className,
  fillColor = 'transparent',
  width = 32,
  height = 32,
}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 721 720"
      enableBackground="new 0 0 721 720"
      xmlSpace="preserve"
      className={className}
    >
      <path
        fill={fillColor}
        opacity="1.000000"
        stroke="none"
        d="
M721.672729,388.786377
 C722.000000,498.260284 721.976074,607.520569 722.103455,716.780762
 C722.107727,720.462219 721.252563,721.095032 717.724670,721.091309
 C611.795654,720.979065 505.866486,721.000000 399.468658,721.000000
 C398.002716,717.675964 400.659485,717.994263 402.413239,717.791321
 C424.317139,715.256775 445.776428,710.724976 466.872406,704.260620
 C496.853241,695.073669 524.975281,681.959595 551.557129,665.392700
 C575.268188,650.614807 597.025818,633.391968 616.850098,613.725525
 C619.005981,611.586792 622.706726,609.244568 620.759155,605.921692
 C618.845154,602.656372 614.935486,604.646362 612.024841,605.425049
 C591.195007,610.997498 569.953857,614.304382 548.536499,616.099548
 C503.920654,619.839172 460.118195,615.017212 417.171295,602.319092
 C402.128326,597.871277 387.378693,592.667603 373.133179,586.084961
 C369.693573,584.495483 366.090942,584.214600 362.393341,584.310425
 C337.468201,584.956421 313.291687,580.815002 289.745605,572.801331
 C259.517181,562.513489 232.745071,546.538208 209.261963,524.790588
 C189.089203,506.108734 172.728943,484.655609 160.656113,460.059357
 C145.540009,429.263031 137.559219,396.740845 137.566772,362.221466
 C137.571823,339.177979 140.748718,316.761841 147.503235,294.792114
 C147.697113,294.161499 147.935852,293.531311 147.690353,292.449707
 C144.522812,294.311035 141.928329,296.743713 139.402283,299.119019
 C123.102020,314.446686 108.223022,331.053314 95.122353,349.213867
 C66.358543,389.087158 47.031155,433.189270 36.107353,481.053955
 C34.622669,487.559387 33.691242,494.159363 32.572765,500.727722
 C31.873093,504.836700 32.868134,508.648132 34.636581,512.342041
 C50.197464,544.845398 69.679016,574.685059 93.770493,601.599609
 C125.096481,636.596252 162.000946,664.081360 204.123932,684.513306
 C240.399017,702.108582 278.738098,713.007690 318.808472,717.723389
 C320.662750,717.941711 323.053650,717.428955 323.213776,720.673096
 C217.072144,721.000000 111.144249,720.975098 5.216547,721.104065
 C1.527882,721.108582 0.905518,720.242737 0.909252,716.722107
 C1.020888,611.460571 1.000000,506.198944 1.000000,400.468658
 C4.363947,398.969757 3.996132,401.684235 4.174567,403.408264
 C6.014818,421.188995 9.712636,438.604767 14.284824,455.855377
 C14.797664,457.790314 15.343166,459.714722 16.154659,461.547485
 C16.788063,462.978027 17.670647,464.233948 19.437706,464.175476
 C21.193687,464.117432 21.981430,462.794952 22.598978,461.368317
 C23.063833,460.294434 23.352167,459.163116 23.665739,458.039429
 C38.443630,405.083435 63.441280,357.524078 99.211311,315.741211
 C116.709717,295.301361 136.345459,277.078857 158.062225,261.162720
 C161.795364,258.426727 164.455414,255.120117 166.699158,251.077667
 C174.973892,236.169510 185.084976,222.605637 196.570984,209.943970
 C215.521423,189.053787 237.708603,172.557175 262.936127,160.257431
 C287.231262,148.412262 312.839874,141.027725 339.930725,138.561478
 C383.429443,134.601547 424.511047,142.593643 463.311584,162.339676
 C480.595490,171.135635 496.483032,182.058289 510.781158,195.299194
 C516.380737,200.484756 522.147522,205.459244 527.139099,211.420090
 C527.016968,207.494873 526.213806,203.807693 525.386169,200.144989
 C515.191589,155.030502 496.608246,113.679855 469.701813,76.053452
 C457.366364,58.803368 443.760284,42.644135 428.533173,27.883883
 C420.281586,19.885281 411.592560,12.365199 402.525970,5.291446
 C401.260559,4.304175 399.465210,3.721189 399.784668,1.310753
 C505.929169,1.000000 611.858398,1.025168 717.787354,0.895124
 C721.486938,0.890582 722.093323,1.772027 722.089783,5.281894
 C721.980103,114.542076 722.000000,223.802383 722.000000,333.531342
 C718.110413,335.039185 718.932373,331.860046 718.785095,330.086243
 C717.071411,309.444366 713.453796,289.140320 708.150024,269.132690
 C694.572754,217.914948 670.654968,172.008987 636.833374,131.291779
 C602.760010,90.271439 561.258667,58.790691 513.100342,36.041012
 C492.401398,26.262962 470.858124,18.788960 448.675598,13.153008
 C446.415131,12.578678 443.847931,11.674726 442.313263,14.163742
 C440.703461,16.774670 442.928802,18.544962 444.551971,20.126873
 C463.500092,38.593212 479.667725,59.291004 493.921814,81.524185
 C522.778076,126.533478 540.965881,175.518570 548.230225,228.482742
 C549.375061,236.829529 551.429932,244.440903 555.691711,251.923355
 C570.536133,277.986298 579.707581,306.053131 583.008484,335.939514
 C587.601501,377.524567 580.766785,417.235138 563.352722,455.202728
 C550.591248,483.026154 532.540833,506.998749 509.842224,527.371033
 C488.158783,546.832153 463.442810,561.431335 435.950928,571.241516
 C426.558441,574.593140 416.975891,577.303955 406.264221,579.760437
 C426.287079,586.963257 445.816010,591.600342 465.752167,594.719971
 C487.708252,598.155762 509.809692,599.507385 531.966003,598.593811
 C571.510376,596.963257 609.996948,589.691284 647.019165,575.360291
 C649.924133,574.235718 652.095520,572.352478 653.889832,569.812988
 C688.505554,520.820923 709.542236,466.522888 717.394409,407.104401
 C718.002502,402.502930 718.685547,397.874969 718.767273,393.193451
 C718.799561,391.340515 718.431702,388.953552 721.672729,388.786377
z"
      />
      <path
        fill="#5CAEB7"
        opacity="1.000000"
        stroke="none"
        d="
M722.000000,388.531342
 C719.815002,388.415283 720.067017,390.065216 720.021790,391.264221
 C719.470947,405.867981 716.988892,420.189545 714.065552,434.476654
 C709.819702,455.226898 703.780334,475.409393 696.001465,495.102966
 C685.224121,522.387329 671.024841,547.766907 654.171936,571.741028
 C652.490234,574.133484 650.480896,575.424927 648.115479,576.355103
 C627.785400,584.349182 606.799072,590.078430 585.323059,593.969543
 C570.800293,596.600769 556.167480,598.158203 541.415527,599.255798
 C528.276550,600.233337 515.148193,600.452942 502.116638,599.803467
 C468.729980,598.139587 436.072601,592.040344 404.496338,580.760376
 C404.062775,580.605469 403.730072,580.168396 402.785614,579.408875
 C414.592468,576.525574 425.801544,573.674927 436.637390,569.674377
 C458.810425,561.488098 479.314178,550.237427 497.913300,535.589844
 C518.801453,519.139526 536.531494,499.754150 550.280212,477.037292
 C563.507019,455.182770 572.890808,431.715790 578.156128,406.541046
 C582.134766,387.518402 583.885071,368.392487 582.867310,349.099731
 C581.989807,332.466888 579.178040,316.049988 574.540955,299.967010
 C568.860779,280.266022 560.477783,261.789154 549.778259,244.372223
 C547.047852,239.927704 547.845459,235.074539 547.253845,230.533646
 C543.935303,205.063995 537.640991,180.417480 529.131287,156.220856
 C516.803467,121.167740 499.123230,89.079247 476.918884,59.375160
 C466.435699,45.351196 455.140869,32.056915 442.432831,20.000517
 C440.281677,17.959675 438.973969,15.766186 440.563904,13.054638
 C442.206055,10.254123 445.068573,10.652415 447.694794,11.339683
 C477.088318,19.031815 505.419525,29.568947 532.119080,44.106510
 C550.172668,53.936447 567.441650,65.024582 583.571228,77.908134
 C597.018127,88.648933 609.982788,99.874268 621.793518,112.364342
 C640.181763,131.810242 656.229675,153.019577 670.097046,175.974823
 C685.604309,201.644653 697.499512,228.809860 706.148010,257.459290
 C710.948547,273.361908 714.850769,289.456665 717.068420,305.958405
 C718.247620,314.732727 720.085327,323.419250 720.024414,332.328705
 C720.018311,333.224335 720.348389,333.935028 721.585327,334.183441
 C722.000000,352.020905 722.000000,370.041779 722.000000,388.531342
z"
      />
      <path
        fill="#436381"
        opacity="1.000000"
        stroke="none"
        d="
M399.531342,1.000000
 C400.943451,4.323304 404.390808,5.033246 406.618622,6.838759
 C418.489899,16.459757 429.837830,26.642895 440.213837,37.819508
 C458.077637,57.061764 473.805939,77.955643 487.233917,100.557686
 C500.833923,123.449326 511.440216,147.661896 519.509644,173.011230
 C523.395447,185.218033 526.187744,197.702057 528.888245,210.206406
 C529.161987,211.474152 528.924988,212.852219 528.924988,214.596848
 C525.454346,212.874863 524.007629,209.613449 521.658691,207.258636
 C506.684387,192.247040 490.352386,178.941345 471.865967,168.412674
 C451.710999,156.933685 430.280670,148.929581 407.657501,143.724503
 C387.117462,138.998688 366.307861,137.923004 345.519928,139.209061
 C315.509918,141.065659 286.944946,149.259354 260.148529,163.015747
 C242.044037,172.310013 225.569489,183.930496 210.524033,197.782578
 C192.117676,214.729004 177.246658,234.187668 165.338486,256.098907
 C162.435226,261.440948 156.466476,263.759247 151.889114,267.395721
 C134.995117,280.817322 119.255226,295.369293 104.856499,311.478912
 C91.748306,326.144684 79.842499,341.661743 69.304314,358.222595
 C55.480427,379.947021 44.115807,402.923401 35.056896,427.039368
 C30.837662,438.271545 27.300528,449.715515 24.020435,461.247925
 C23.346687,463.616760 22.834465,466.160797 19.365992,466.028687
 C16.142984,465.905945 15.350432,463.733429 14.608376,461.231781
 C10.450905,447.215881 7.298723,432.991302 4.878645,418.564514
 C3.834967,412.342834 4.087173,405.900940 1.422280,399.940430
 C1.000000,374.312439 1.000000,348.624878 1.000000,322.468658
 C3.018677,319.011078 1.988249,315.529602 2.432712,312.306793
 C11.863868,243.921036 38.561829,183.111649 82.598000,130.015259
 C122.303734,82.140274 171.252670,46.856457 229.106232,23.992033
 C256.489441,13.169853 284.793396,5.875124 314.022949,2.190766
 C316.487274,1.880138 319.035339,2.548141 321.709137,1.245967
 C347.687561,1.000000 373.375122,1.000000 399.531342,1.000000
z"
      />
      <path
        fill="#1486C2"
        opacity="1.000000"
        stroke="none"
        d="
M323.468658,721.000000
 C323.662140,719.139221 322.283142,719.122620 321.141510,719.025574
 C292.472198,716.588867 264.831604,709.581970 237.808533,700.004639
 C203.808670,687.954529 172.500046,670.851257 143.674942,649.181580
 C127.396431,636.943909 112.117729,623.554749 98.235641,608.661621
 C80.070549,589.173584 64.124557,567.978027 50.514332,545.045471
 C44.991814,535.740295 40.373829,525.946045 35.055408,516.547180
 C30.878242,509.165222 30.468212,501.751740 32.078327,493.756592
 C36.043301,474.068359 41.080048,454.681946 47.975990,435.807404
 C56.865376,411.476715 68.039070,388.285919 81.992973,366.403839
 C92.341805,350.175110 103.932983,334.999176 116.701645,320.589233
 C126.724411,309.278137 137.722595,299.094635 148.936691,288.814728
 C150.490707,290.276489 149.957672,291.592896 149.514450,293.004181
 C144.603500,308.641479 141.350220,324.535431 139.844116,340.942719
 C136.310196,379.440521 142.455612,416.159821 158.086761,451.401245
 C168.219223,474.245514 181.985397,494.571350 199.134628,512.817322
 C215.482437,530.210754 234.048782,544.427795 254.840042,556.043274
 C275.733704,567.716003 298.070526,575.268188 321.389923,579.815735
 C335.139923,582.497192 349.193146,583.929321 363.251129,582.885071
 C370.380951,582.355591 375.914856,586.038452 381.842438,588.524963
 C404.801910,598.156250 428.593628,605.032043 452.952332,609.737854
 C463.685608,611.811401 474.607239,613.222961 485.586639,614.201172
 C500.627380,615.541321 515.667175,616.609863 530.703552,615.856018
 C545.765930,615.100891 560.800537,613.793091 575.761047,611.315552
 C588.996704,609.123657 602.086975,606.571411 615.065125,603.215332
 C617.429993,602.603821 621.227234,601.421692 622.712219,604.716736
 C624.042847,607.669128 622.174683,610.360657 619.911011,612.604614
 C603.036194,629.332764 585.024231,644.656128 565.301941,657.983459
 C548.316223,669.461548 530.700012,679.811279 512.093506,688.378479
 C486.976288,699.943604 460.937653,708.795593 433.720947,714.046753
 C422.624298,716.187744 411.582642,718.583862 400.243835,719.104370
 C399.718964,719.128479 399.223633,719.796143 398.857239,720.582031
 C373.979095,721.000000 348.958221,721.000000 323.468658,721.000000
z"
      />
      <path
        fill={fillColor}
        opacity="1.000000"
        stroke="none"
        d="
M321.531342,1.000000
 C322.364349,2.733906 321.201782,2.874399 319.961700,2.988441
 C292.835785,5.482981 266.582489,11.879000 240.965805,20.952333
 C205.014160,33.686275 171.980682,51.787571 141.558121,74.823463
 C123.760056,88.300125 107.797768,103.749428 92.726479,120.031250
 C75.822800,138.292648 61.366814,158.542786 48.971668,180.175797
 C35.835777,203.101608 24.942108,227.055786 17.084963,252.300003
 C10.984632,271.899780 6.374736,291.846863 3.751774,312.265686
 C3.340569,315.466797 4.365942,319.241821 1.419072,322.061951
 C1.000000,216.405365 1.024995,110.810692 0.895874,5.216207
 C0.891362,1.526592 1.758535,0.905597 5.278223,0.909327
 C110.539619,1.020863 215.801163,1.000000 321.531342,1.000000
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M159.999084,413.959534
 C157.595474,404.784790 155.952026,395.905731 154.958359,386.878296
 C153.878220,377.065186 152.623138,367.248688 153.049973,357.375427
 C154.154373,331.829712 158.590042,307.003876 168.270111,283.118378
 C175.902985,264.284332 185.940033,246.854828 198.592560,231.207199
 C214.005600,212.145554 232.203049,195.895752 253.376755,183.143036
 C272.673279,171.520935 293.340485,163.385956 315.222290,158.463699
 C327.466827,155.709305 339.894196,153.716614 352.572510,153.962128
 C364.325623,154.189758 376.135376,153.366638 387.806274,155.076355
 C398.010864,156.571243 408.125916,158.705322 418.062958,161.537659
 C440.191620,167.844925 460.694458,177.518478 479.514252,190.839493
 C495.370148,202.062637 509.398773,215.054626 521.796875,230.089706
 C538.970032,250.915421 551.224487,274.201691 559.314026,299.789337
 C563.317505,312.452637 565.607788,325.459412 567.141602,338.684479
 C568.642639,351.626556 568.404114,364.581909 567.758362,377.431213
 C566.972229,393.075378 563.561646,408.458191 558.872803,423.485687
 C551.567139,446.900452 540.340942,468.381897 525.513184,487.768494
 C509.280457,508.991913 489.318817,526.304993 466.285767,539.977478
 C447.491516,551.133850 427.322174,559.039673 406.093201,563.819214
 C389.903900,567.464111 373.333893,568.180237 356.667633,568.148071
 C327.950409,568.092712 300.864563,561.523071 274.795837,549.978333
 C257.568146,542.348938 241.937164,532.232361 227.523193,520.096008
 C204.614395,500.807129 186.472992,477.811920 173.485855,450.866150
 C167.849335,439.171478 163.328735,426.977325 159.999084,413.959534
z"
      />
      <path
        fill="#184089"
        opacity="1.000000"
        stroke="none"
        d="
M471.738129,317.253540
 C478.022644,332.270813 484.151794,346.936340 490.516327,362.165070
 C481.978668,362.165070 474.168152,362.099213 466.360046,362.207916
 C464.205536,362.237915 463.541504,361.059387 462.893860,359.388855
 C460.732758,353.814545 458.233856,348.358032 456.348785,342.695129
 C455.294373,339.527496 453.613220,338.876953 450.550293,338.930756
 C439.890869,339.117950 429.223755,339.129211 418.564941,338.925140
 C415.430603,338.865143 413.840881,339.662964 412.874329,342.801331
 C411.165710,348.349060 408.948853,353.740967 406.921112,359.189270
 C406.351868,360.718658 405.966888,362.246857 403.660095,362.210052
 C395.878448,362.085876 388.093597,362.162750 379.683472,362.162750
 C384.712585,350.121094 389.475494,338.653412 394.288269,327.206696
 C404.139557,303.776337 414.082245,280.384003 423.801636,256.899200
 C424.998779,254.006607 426.274048,252.703293 429.507568,252.927277
 C434.478027,253.271545 440.613495,251.420135 444.148499,253.727325
 C447.639404,256.005768 448.593048,262.258545 450.523560,266.825378
 C457.574097,283.504517 464.567719,300.207703 471.738129,317.253540
z"
      />
      <path
        fill="#184089"
        opacity="1.000000"
        stroke="none"
        d="
M237.887573,270.156372
 C235.984161,265.134552 234.249527,260.463043 232.379242,255.846527
 C231.474670,253.613678 232.080597,252.931091 234.433395,252.963348
 C241.425461,253.059219 248.425659,253.166718 255.410370,252.920502
 C258.560364,252.809464 258.787048,254.921341 259.503357,256.890381
 C266.998871,277.494324 274.479889,298.103516 282.004761,318.696716
 C282.548859,320.185760 282.630249,321.964294 284.548401,323.307190
 C289.761200,309.184296 294.906891,295.260620 300.039062,281.332001
 C303.080353,273.077942 306.160706,264.837402 309.092529,256.544495
 C309.954315,254.106873 310.946106,252.778107 313.953400,252.903870
 C320.909546,253.194809 327.886139,252.996353 335.581879,252.996353
 C331.484070,263.347595 327.616669,273.187195 323.696503,283.005737
 C313.786438,307.826691 303.770081,332.605835 294.017670,357.488495
 C292.561127,361.204834 290.703094,362.349426 286.755768,362.275970
 C272.766510,362.015656 272.803162,362.168701 267.897369,349.219025
 C257.956940,322.979553 247.968918,296.758179 237.887573,270.156372
z"
      />
      <path
        fill="#1B428A"
        opacity="1.000000"
        stroke="none"
        d="
M358.978333,362.176086
 C354.512512,362.075531 349.229431,363.489929 346.910217,361.481598
 C344.159515,359.099701 346.048889,353.658997 346.037354,349.561188
 C345.951263,318.911163 346.052826,288.260437 345.907043,257.610870
 C345.889984,254.018448 346.544189,252.579758 350.463593,252.897736
 C355.262756,253.287079 360.137115,253.257446 364.942047,252.905258
 C368.723755,252.628082 369.663391,253.823990 369.642914,257.570435
 C369.482758,286.887207 369.554230,316.205261 369.554260,345.522919
 C369.554260,349.520782 369.311951,353.537689 369.624847,357.510895
 C369.915833,361.205566 368.809418,362.781128 364.963531,362.220734
 C363.169250,361.959259 361.305328,362.176086 358.978333,362.176086
z"
      />
      <path
        fill="#1F468D"
        opacity="1.000000"
        stroke="none"
        d="
M375.052216,397.878296
 C392.405121,410.153259 396.222900,432.846741 383.929840,448.914429
 C372.160278,464.297913 349.008789,466.489105 333.710693,453.667511
 C323.287231,444.931427 319.299316,428.610077 324.235199,414.887238
 C328.957214,401.758972 341.518066,393.134369 355.691345,392.928345
 C362.532928,392.828918 368.870178,394.174042 375.052216,397.878296
z"
      />
      <path
        fill="#1E448C"
        opacity="1.000000"
        stroke="none"
        d="
M285.981049,434.933899
 C289.040680,441.987976 292.053833,448.649750 294.870850,455.393463
 C295.459198,456.801880 297.654602,459.196869 295.294495,459.850403
 C292.969055,460.494263 289.290192,461.930450 287.712128,457.671814
 C286.211853,453.623047 284.320648,449.720276 282.775177,445.686707
 C282.025116,443.729065 281.046021,442.913116 278.796082,442.952026
 C269.801208,443.107635 260.799530,443.134277 251.806000,442.944122
 C249.110748,442.887085 248.011642,444.026367 247.144485,446.277527
 C245.711411,449.997833 243.828903,453.553040 242.523697,457.312500
 C240.951538,461.840851 237.386948,460.106781 234.572174,459.933441
 C232.850449,459.827393 233.942352,458.014832 234.325546,457.133881
 C243.072342,437.023895 251.927383,416.960815 260.603333,396.820496
 C261.686127,394.306976 263.419891,394.587769 265.403229,394.387299
 C267.944580,394.130493 268.884033,395.572296 269.741486,397.555939
 C275.081390,409.909149 280.483429,422.235474 285.981049,434.933899
z"
      />
      <path
        fill="#21478E"
        opacity="1.000000"
        stroke="none"
        d="
M439.779785,421.175507
 C448.189880,429.908630 449.888336,440.739136 444.560486,450.169861
 C439.655518,458.851990 429.688568,463.089081 419.321716,461.015442
 C415.098999,460.170776 411.723022,457.892120 408.189850,454.771515
 C407.054077,458.743347 407.691467,462.480652 407.613708,466.135529
 C407.493378,471.791138 407.523254,477.452087 407.609497,483.108948
 C407.645874,485.493439 407.614319,487.147369 404.316376,487.142212
 C401.205963,487.137360 400.922821,485.845428 400.932404,483.302124
 C401.011444,462.333893 400.972412,441.365234 400.986084,420.396698
 C400.987213,418.670349 400.386536,416.577423 403.474182,416.765900
 C405.686035,416.900940 408.019958,416.454559 407.610870,419.920502
 C407.536621,420.549438 407.767609,421.214417 407.919556,422.308380
 C418.265839,413.842957 428.766785,413.210602 439.779785,421.175507
z"
      />
      <path
        fill="#20468D"
        opacity="1.000000"
        stroke="none"
        d="
M480.101105,418.700043
 C481.290955,419.661041 482.335114,420.303833 482.993713,421.222900
 C483.739105,422.263031 485.869659,423.601440 483.787537,424.790588
 C482.176849,425.710480 480.372253,428.814972 477.941254,425.669647
 C475.055054,421.935333 471.174286,421.026581 466.784698,422.072327
 C463.909607,422.757324 461.450745,424.155914 461.058105,427.496399
 C460.641876,431.037476 462.999146,432.675659 465.839478,433.556519
 C469.162109,434.586945 472.610718,435.204498 475.986938,436.070312
 C482.298889,437.688995 485.929291,441.741974 486.185822,447.370728
 C486.483978,453.912781 483.483734,458.225647 477.028534,460.534271
 C469.217651,463.327759 459.322815,461.421631 454.781250,456.106781
 C453.882965,455.055511 451.627563,453.766357 454.065979,452.159729
 C455.730652,451.062958 457.254883,448.301666 459.773438,451.471069
 C463.553070,456.227386 468.661377,456.952850 474.212402,455.255463
 C477.111023,454.369110 479.205658,452.547791 479.368622,449.269836
 C479.530182,446.019989 477.361450,444.452667 474.678894,443.623230
 C471.353546,442.595032 467.921875,441.916473 464.567444,440.975250
 C457.439819,438.975311 453.818054,434.809998 453.988586,428.939911
 C454.166779,422.806488 458.143250,418.621552 465.259003,416.816010
 C470.352783,415.523529 475.143768,416.215637 480.101105,418.700043
z"
      />
      <path
        fill="#183F89"
        opacity="1.000000"
        stroke="none"
        d="
M304.002014,457.797516
 C303.997711,437.827850 304.002136,418.340759 303.990814,398.853638
 C303.989471,396.539337 303.447266,394.395447 307.270447,394.316589
 C311.160919,394.236328 311.039978,396.190826 311.032196,398.900208
 C310.977051,418.054047 311.025238,437.208221 310.951752,456.361938
 C310.946899,457.622986 311.956818,459.891083 309.699524,459.977234
 C307.801666,460.049683 304.967377,461.819916 304.002014,457.797516
z"
      />
      <path
        fill="#F4F6F9"
        opacity="1.000000"
        stroke="none"
        d="
M433.033569,318.568024
 C421.709595,318.568909 421.707062,318.567932 425.507355,308.508484
 C428.207001,301.362518 430.909668,294.217682 433.638519,287.082886
 C433.739716,286.818359 434.131561,286.665009 434.615967,286.277405
 C438.439148,296.063690 442.179382,305.782104 446.052856,315.447144
 C446.977631,317.754578 446.837250,318.746674 444.019653,318.608337
 C440.528168,318.436890 437.021881,318.567841 433.033569,318.568024
z"
      />
      <path
        fill="#FDFDFE"
        opacity="1.000000"
        stroke="none"
        d="
M383.305267,429.801910
 C381.993256,442.932800 373.890778,452.771454 362.843384,454.991119
 C350.768890,457.417145 339.315735,452.267792 333.644562,441.863312
 C327.558105,430.696869 329.540527,415.654266 338.283966,406.660461
 C345.876831,398.850067 358.857361,396.804871 368.690491,402.037689
 C379.613434,407.850525 383.698761,417.442993 383.305267,429.801910
z"
      />
      <path
        fill="#F8F9FB"
        opacity="1.000000"
        stroke="none"
        d="
M272.810974,422.216553
 C274.387695,426.109406 275.686157,429.710114 277.316864,433.153473
 C278.626129,435.918121 278.289642,436.951904 274.978668,436.884735
 C267.168884,436.726288 259.353638,436.833923 250.828766,436.833923
 C255.428680,425.624573 259.873077,414.794220 264.730927,402.956421
 C267.603210,409.788940 270.139709,415.822693 272.810974,422.216553
z"
      />
      <path
        fill="#FDFDFE"
        opacity="1.000000"
        stroke="none"
        d="
M420.194397,455.044830
 C411.177948,451.859131 406.521881,445.320099 407.313904,437.434906
 C408.147095,429.140015 413.377747,423.173035 421.119934,421.940857
 C427.893066,420.862946 433.724609,422.647217 437.732269,428.489227
 C441.635101,434.178406 441.648956,443.315125 437.658691,448.761658
 C433.437897,454.522919 427.675537,456.761658 420.194397,455.044830
z"
      />
    </svg>
  );
};
